import { Typography } from "@mui/material";

export const paymentBreakDownTestProps = {
  paymentDetail: {
    status: "paid",
    paidOn: "2024-01-15",
    paymentDate: "2024-01-15",
    totalPayroll: 10000,
    totalBonus: 1000,
    totalCreditAdjusted: 500,
    totalEmployees: 25,
  },
  customerPayment: {
    rows: [],
    count: 0,
    totalPayroll: 15000,
    totalBonus: 1500,
    totalCreditAdjusted: 750,
    totalEmployees: 30,
  },
  navigatedFrom: "paymentDetails",
  salariesPage: false,
  selectedOptions: [],
  resetPage: false,
};

export const tabHeadings = ["Overview", "Important Notices"];

export const noticeTableHeaders = [
  {
    id: "customerName",
    numeric: false,
    disablePadding: true,
    sort: false,
    label: (
      <Typography variant="h5" fontSize="14px">
        Customer Name
      </Typography>
    ),
  },
  {
    id: "noticeText",
    numeric: false,
    disablePadding: true,
    sort: false,
    label: (
      <Typography variant="h5" fontSize="14px">
        Notice
      </Typography>
    ),
  },
  {
    id: "date",
    numeric: false,
    disablePadding: true,
    sort: false,
    label: (
      <Typography variant="h5" fontSize="14px">
        Date
      </Typography>
    ),
  },
];

export const PAYMENT_TYPE_DROPDOWN_OPTIONS = [
  {
    label: "One Time",
    value: "One-time",
  },
  {
    label: "Monthly",
    value: "Monthly",
  },
  {
    label: "Onboarding",
    value: "Onboarding",
  },
];

export const PAYMENT_STATUS_DROPDOWN_OPTIONS = [
  {
    label: "Pending",
    value: "pending",
  },
  {
    label: "Failed",
    value: "failed",
  },
  {
    label: "Paid",
    value: "paid",
  },
];

export const PAYMENT_HISTORY_TABLE_ROWS_PER_PAGE_OPTIONS = [10, 50, 100];

export const PAYMENT_HISTORY_SORT_FIELD_MAP = {
  billingPeriod: "billingPeriod",
  billedOn: "billedOn",
  paidOn: "paidOn",
  dueDate: "dueDate",
  status: "status",
};
